import { render, staticRenderFns } from "./MutacionesBiomarcadores.vue?vue&type=template&id=099fa70b&scoped=true&"
import script from "./MutacionesBiomarcadores.vue?vue&type=script&lang=js&"
export * from "./MutacionesBiomarcadores.vue?vue&type=script&lang=js&"
import style0 from "./MutacionesBiomarcadores.vue?vue&type=style&index=0&id=099fa70b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fa70b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
